<template>
  <div class="content">
    <div style="display: none!important;">
      <electron-vue-printer
        ref="electronVuePrinter"
        :show="true"
        :options="options"
        :rotateType="rotateType"
        @webview-ready="Printer"
        @start-printing="Starprinting"
        :silent="true"
      >
      </electron-vue-printer>
    </div>
    {{print}}
    <div id="my-node">
      <h5>
        <div class="text-center" v-if="print_type != ''"><b>{{ print_type }}</b></div>
        <div class="row">
        <div class="col-md-2">
          <b>№{{ datas != null ? datas.id : '' }}</b>
        </div>
        <div class="col-md-10" style="text-align: center;">
          <span>
            <b>{{ datas != null ? datas.sklad.name : '' }}</b>
          </span>  
        </div>
        <div class="col-md-12">
          Контрагент: {{ datas != null ? datas.kontragent.name : '' }}
        </div>
        <div class="col-md-12" v-if="datas != null">
          {{ $t("Сана") }}: {{ Datetime(datas.datetime) }}
        </div>
      </div>
      </h5>
      <ul v-if="datas != null">
        <li>
          <span>{{ $t("Тури") }}</span>
        </li>
        <li style="text-align: right;">
          {{ datas.type == true ? $t("Кирим") : $t("Расход") }}
        </li>
      </ul>
      <ul v-if="datas != null">
        <li>
          <span>{{ $t("Тўлов тури") }}</span>
        </li>
        <li style="text-align: right;">
          {{ datas.pay_type.name == 'Доллар' ? 'Валюта' : datas.pay_type.name }}
        </li>
      </ul>
      <ul>
        <li>
          <span v-if="datas != null">Сумма</span>
        </li>
        <li style="text-align: right;" v-if="datas != null">
          {{ datas.summa|numFormat }}
        </li>
      </ul>
      <ul>
        <li v-if="datas != null">
          <span>{{ $t("Қарздорлик") }} сўм</span>
        </li>
        <li style="text-align: right;">
          {{ current_total | numFormat }}
        </li>
      </ul>
      <ul>
        <li v-if="datas != null">
          <span>{{ $t("Қарздорлик") }} валюта</span>
        </li>
        <li style="text-align: right;">
          {{ current_total_dollar | numFormat }}
        </li>
      </ul>
      <ul>
        <li v-if="datas != null">
          <b>{{ $t("Жами сумма") }}:</b>
          <b style="float: right;">{{ datas.summa|numFormat }}</b>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import electronVuePrinter from "electron-vue-printer";
export default {
  name: "Printoplata",
  components: { electronVuePrinter, htmlToImage },
  data() {
    return {
      print:'false',
      print_type: '',
      printer: '',
      datas: null,
      current_total: 0,
      current_total_dollar: 0,
      rotateType: 0,
      axiosRes: {
        qarzdorlik: false,
        sklad: false,
        printName: false
      },
      options: {
        offsetX: 0,
        offsetY: 0,
        imageWidth: 300
      }
    };
  },
  async updated(){
    if(this.print=='print'){
      this.$refs.electronVuePrinter.deviceNamePrint = this.printer.check_printer_name;
      await this.$refs.electronVuePrinter.print(this.dataUrl);
    }
  },
  created: function() {
    this.Data();
    this.GetPrinterName();
    if(localStorage.getItem("print_type")){
      this.print_type = localStorage.getItem("print_type");
    }
  },
  methods: {
    GetPrinterName(){
      let self = this;
      axios({
        method: "post",
        url: "api/v1/sklad-settings",
        data: { sklad_id: localStorage.getItem('sklad_id'), key: 'a4_printer' }
      }).then(function (response) {
        if (response.data.data != null) {
          self.printer = JSON.parse(response.data.data);
        }
      });
    },
    Starprinting(data){
      if(data==true){
        setTimeout(() => {
          localStorage.removeItem("print_type");   
          window.close();
        }, 3000);
      }
    },
    async Printer() {
      let self = this;
      if(self.axiosRes.qarzdorlik){
      var node = document.getElementById("my-node");
     await htmlToImage
        .toSvg(document.getElementById("my-node"))
        .then(function(dataUrl) {
          self.dataUrl=dataUrl;
            self.print='print';            
        })
        .catch(function(error) {
          console.error("oops, something went wrong!", error);
        });
      }else{
        console.log('no')
        setTimeout(() => {
          self.Printer()
        }, 1000);
      }
    },
    Data() {
      let self = this;
      axios
        .get("api/v1/kontragent-pay/id/" + self.$route.params.id)
        .then(function(response) {
          self.datas = response.data;
          self.GetTotalDebt();
        });
    },
    GetTotalDebt(){
      let self = this;
      self.current_total = 0;
      self.current_total_dollar = 0;
      axios({
        method: "post",
        url: "api/v1/kontragent/total",
        data: {
          kontragent_id: self.datas.kontragent_id,
          sklad_id: self.datas.sklad_id,
          datetime: null
        }
      }).then(function(response) {
        response.data.forEach(element => {
          if(element.pay_type_id == 3){
            self.current_total_dollar = element.total;
          } else{
            self.current_total += element.total;
          }
        });
        // self.print = true;
        self.axiosRes.qarzdorlik = true;
      });
    },
    Datetime(datetime) {
      var d = new Date(datetime * 1000);
      var dt = d.getDate();
      var month = d.getMonth() + 1;
      var hour = d.getHours();
      var minut = d.getMinutes();
      var sekund = d.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (dt < 10) {
        dt = "0" + dt;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minut < 10) {
        minut = "0" + minut;
      }
      if (sekund < 10) {
        sekund = "0" + sekund;
      }

      return dt + "." + month + "." + d.getFullYear() + " " + hour+":"+minut+":"+sekund;
    }
  }
};
</script>
<style scoped>
#my-node {
  padding: 0 12px!important;
  width: 300px;
}

h5 {
  font-weight: bold;
  font-size: 13px;
  color: black;
}

ul {
  list-style: none;
  border-bottom: 1px dotted;
  text-align: left;
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: black;
}
</style>
